import { render, staticRenderFns } from "./EventTemplate.vue?vue&type=template&id=6924ec62&"
import script from "./EventTemplate.vue?vue&type=script&lang=ts&"
export * from "./EventTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports